<template>
  <div class="orderCenter">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="订单编号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.order_sn }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单明细" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payment_type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="下单时间" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.creationTime | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center">
        <template slot-scope="scope">
          <span>￥{{ scope.row.order_price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.payment_time">{{
            scope.row.payment_time | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
        </template>
      </el-table-column>
      <!--<el-table-column  label="支付渠道" align="center">-->
      <!--<template slot-scope="scope">-->
      <!--<span>{{ scope.row.payment_channel }}</span>-->
      <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column label="订单状态" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payment_status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递单号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.express_number }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递公司" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.express_company }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click="toPay(scope.row)"
            type="text"
            size="small"
            v-if="
              scope.row.payment_status == '待支付' ||
              scope.row.payment_status == '支付失败'
            "
            >去支付
          </el-button>
          <el-button
            @click="view(scope.row)"
            type="text"
            size="small"
            v-if="scope.row.payment_status == '支付成功'"
            >查看物流
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="二维码支付"
      :visible.sync="paydialog"
      :width="screenWidth > 768 ? '40%' : '90%'"
      center
      :close-on-click-modal="false"
    >
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img" />
        <div v-if="showTip">仅支持微信扫码支付</div>
      </div>
    </el-dialog>
    <div class="pagination" style="margin-top: 55px; text-align: center">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount > 8"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { GetPersonalOrderRecord } from "@/api/admin/appraiser.js";
import {
  GDCloudPayV1,
  GDCloudPay,
  GDCloudPayV2,
  GetPaymentStatus,
} from "@/api/admin/common.js";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["screenWidth"]),
  },
  data() {
    return {
      formData: {},
      payview: false,
      paydialog: false,
      paytime: null,
      sn: null,
      tableData: [],
      paging: {
        limit: 8,
        page: 1,
      },
      imgPath: window.apiObj.apiUrl,
      totalCount: 0,
      showTip: false,
    };
  },
  beforeDestroy() {
    clearTimeout(this.paytime);
  },
  created() {
    this.getList();
    this.intervalPay();
    this.paytime = setInterval(() => {
      this.intervalPay();
    }, 10000);
  },
  methods: {
    intervalPay() {
      if (this.payview) {
        if (this.sn != null) {
          GetPaymentStatus({ order_sn: this.sn }).then((data) => {
            if (data.data.result.orderStatus == 3) {
              this.$message({
                message: "支付完成",
                type: "success",
              });
              this.paydialog = false;
              this.payview = false;
              this.sn = null;
              this.getList();
            }
          });
        }
      }
    },
    toPay(row) {
      // this.$message({
      //   message: "订单确认中",
      //   type: "success"
      // });
      this.sn = row.order_sn;
      this.showTip = false;

      if (row.payment_typeValue == 6) {
        this.$confirm(
          "机构代缴测试报名费，发票将直接以个人抬头开给运动员。",
          "确认信息",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
          }
        ).then(() => {
          GDCloudPay({ order_sn: this.sn }).then((data) => {
            if (data.data.result.isSuccess) {
              this.paydialog = true;
              this.payview = true;
              this.formData.img = this.imgPath + data.data.result.payCode;
            }
          });
        });
      } else if (row.payment_typeValue == 2) {
        GDCloudPay({ order_sn: this.sn }).then((data) => {
          if (data.data.result.isSuccess) {
            this.paydialog = true;
            this.payview = true;
            this.formData.img = this.imgPath + data.data.result.payCode;
          }
        });
      } else if (row.payment_typeValue == 3) {
        this.showTip = true;
        GDCloudPayV1({ order_sn: this.sn }).then((data) => {
          if (data.data.result.isSuccess) {
            this.paydialog = true;
            this.payview = true;
            this.formData.img = this.imgPath + data.data.result.payCode;
          }
        });
      } else if (row.payment_typeValue == 1 || row.payment_typeValue == 4) {
        this.showTip = true;
        GDCloudPayV2({ order_sn: this.sn }).then((data) => {
          if (data.data.result.isSuccess) {
            this.paydialog = true;
            this.payview = true;
            this.formData.img = this.imgPath + data.data.result.payCode;
          } else {
            this.$message({
              message: data.data.result.errorMsg,
              type: "error",
            });
          }
        });
      }
    },
    getList() {
      GetPersonalOrderRecord(Object.assign(this.paging)).then((data) => {
        let list = data.data.result;

        this.totalCount = list.totalCount;
        if (list.items.length > 0) {
          this.tableData = list.items;
        }
      });
    },
    handleCurrentChange(page) {
      this.paging.page = page;
      this.getList();
    },
    view(row) {
      this.$router.push({
        path: "/personal/gradeCertificateDelivery/logistics",
        query: { id: row.express_number },
      });
    },
  },
  filters: {
    // status: i => {
    //   switch (i) {
    //     case 0:
    //       return "未完成";
    //     case 1:
    //       return "已完成";
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
.paystyle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  color: #ea0000;
}
</style>
